import {MIX_VIEW} from 'constants/view-modes.js';
import {isInputEvent} from "utils/isInputEvent.js";
import {EFFECT, TRACK, ZOBJECT} from 'constants/object-types.js';
import {segmentCables} from 'messaging/cables/segmentCables.js';
import {
    arrangementBackspace,
} from 'components/arrangement/key.js';
import {
    TRACKER_PARAMETERS,
} from 'components/mix/mix2/trackerUtils.js';
import {groupSteps} from 'pattern/groups/stepGroups.js';
import {sleep} from 'utils/sleep.js';
import {legato, rollSteps, tripletSteps} from 'pattern/utils/legato.js';
import {duplicateSteps} from 'pattern/utils/duplicateSteps.js';
import {SAMPLER} from 'constants/track-types.js';
import {
    setShowSearchWindow,
    setUXLocked,
    setSidebarViewMode,
    setCurrentSoundInList,
    setCurrentTagInList,
    setStepsGroupMode,
    setTracksToHide,
    setSelectedTrackSlice,
    setArrangementBottomMode,
    setTrackToConvert,
    setFullScreenZObject,
    setTrackerParameterToEdit
} from 'actions/index.js';
import {PIANO_ROLL, WAVEFORM} from 'constants/arrangement-modes.js';
import {NUMBER_TO_RESOLUTION} from 'constants/resolution-keys.js';
import {
    setSidebarsShowing,
    setPianoRollCursor,
    setSampleExplorerSelected,
    setAutomationPointDragging,
    setPresentationMode,
    setSelectedFreeze,
    setAutomationPointsSelected,
    setAutomationSelection,
    setAutomationPointHasMoved,
    setAutomationGuidePoint,
} from 'actions/index.js';
import {
    SOUNDS,
    EXTERNAL,
    SEQUENCES,
    PRESETS,
    INSTRUMENTS,
    NOTES} from 'constants/sidebar-view-modes.js';
import {setStepNumberDraggedTo} from 'actions/index.js';
import {setCurrentScene} from 'actions/index.js';
import Resolution from 'engine/Resolution.js';
import {setSelectedPianoRollSteps} from 'actions/index.js';
import {setViMode} from 'actions/index.js';
import {setCommandPrefix} from 'actions/index.js';
import {setIsRecording} from 'actions/index.js';
import {
    moveSteps,
    removeAutomationBreakPoints,
    deleteSteps} from 'operations/actions.js';
import {setCommandDown} from 'actions/index.js';
import {
    setCirklonParameterSelected,
    setCirklonMode
} from 'actions/index.js';
import {setStepsToCopy} from 'actions/index.js';
import {setEasyPatternToCopy} from 'actions/index.js';
import {setErasingAutomation} from 'actions/index.js';
import {setShowArrangementSearcher} from 'actions/index.js';
import {isNumber} from 'utils/IsNumber.js';
import {toggleStep} from 'operations/actions.js';
import {MAP, DELETE, OFF} from 'constants/midi-map-modes.js';
import {ARRANGEMENT_VIEW} from 'constants/view-modes.js';
import {MULTI_DETAILS_VIEW} from 'constants/view-modes.js';
import {PREFERENCES_VIEW} from 'constants/view-modes.js';
import {SOUND_DETAILS_VIEW} from 'constants/view-modes.js';
import {SEQUENCER_VIEW} from 'constants/view-modes.js';
import {setSelectorMode} from 'actions/index.js';
import {
    setSelectedZObject,
    setShowPianoRoll} from 'actions/index.js';
import Arrowable from './key/Arrowable.js';
import {hideAllEffects, setShowSequences, setShowPresets, setShowInstruments} from 'actions/index.js';
import {setShowSequenceModal} from 'actions/index.js';
import {setTrackRolling} from 'actions/index.js';
import {setTrackFocused} from 'actions/index.js';
import {setIsPlayingMix, setShowGroups} from 'actions/index.js';
import {setViewMode} from 'actions/index.js';
import {setMidiMapMode} from 'actions/index.js';

const MAX_META_TIME = 5000;

class KeyListener extends Arrowable(class{}) {
    constructor(sequencerEngine, installation) {
        super();
        this.sequencerEngine = sequencerEngine;
        this.disableTab = installation;
        this.installation = installation;
        this.store = sequencerEngine.store;
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.keysDown = {};
        this.effectToCopy = undefined;
        this.sequencerEngine.keyListener = this;
        this.checkMetaKey();
        this.lastViewMode = undefined;
        this.halftime = undefined;

        this.bindings = {};
    }

    addBinding(key) {
        this.bindings[key] = true;
    }

    removeBinding(key) {
        delete this.bindings[key];
    }

    checkMetaKey() {
        setInterval(() => {
            if (this.lastMetaPressedTime === undefined) {
                return;
            }
            let time = new Date().getTime();
            if (time - this.lastMetaPressedTime >= MAX_META_TIME) {
                this.dispatch(setCommandDown(false));
            }
        }, 1000);
    }

    onKeyUp(event) {
        this.keysDown[event.key && event.key.toLowerCase()] = false;
        if (isInputEvent(event)) {
            return;
        }
        if (event.key === 'Meta' || event.key === 'Control') { 
            this.lastMetaPressedTime = undefined;
            this.dispatch(setCommandDown(false));
        } else if (event.key === '/') {
            this.dispatch(
                setShowSearchWindow(!this.state.spatial.showSearchWindow));
        } else if (event.key === '~' || event.key === '\`') {
            if (this.halftime !== undefined) {
                this.sequencerEngine.subSequences.forEach(
                    (x,i) => x.playhead.speedFactorParameter.set(
                        this.halftime[i], false));
                this.halftime = undefined;
            }
            if (event.key === '\`') {
                this.sequencerEngine.sequenceRolling = false;
            }
        } else if (!isNumber(event.key)) {
            this.sequencerEngine.keyboardHelper.onKeyUp(event);
        }
    }

    onKeyDown(event) {
        if (this.keysDown[event.key && event.key.toLowerCase()] && !event.ctrlKey && !event.metaKey) {
            return;
        }
        if (isInputEvent(event)) {
            if (event.key === 'd' && event.metaKey) {
            } else {
                return;
            }
        }
        this.keysDown[event.key && event.key.toLowerCase()] = true;


        if (this.state.sequencer.loadingText) {
            return;
        }

        if (this.bindings[event.key] && !event.ctrlKey && !event.metaKey) {
            if (!this.sequencerEngine.isAnyTrackEnabled()) {
                return;
            }
        }

        if (event.keyCode == 32 && event.target == window.document.body ) {
            event.preventDefault();
            if (this.viewMode === ARRANGEMENT_VIEW ||
                this.state.arrangement.looping) {
                if (!this.sequencerEngine.playing) {
                    this.dispatch(setIsPlayingMix(true));
                        
                }
            }
            if (window.synthz) {
                return;
            }
            this.sequencerEngine.schedulePlay();
            return false;
        }

        let isClickOnBody = event.target === window.document.body;

        if (this.viMode && !event.metaKey && !event.ctrlKey && !event.ctrlKey) {
            if (event.key === 'Escape') {
                this.dispatch(setViMode(false));
                return;
            } else {
                this.scripting.viCommand(event.key);
                if (isNumber(event.key)) {
                    return;
                }
            }
        }

        if (event.key === 'Space') {
            return;
        }

        if (!this.viMode &&
            event.key >= 'a' &&
            event.key <= 'z' &&
            !event.metaKey &&
            !event.ctrlKey &&
            !event.ctrlKey)
        {
            this.sequencerEngine.keyboardHelper.onAlphabetKeyDown(
                event, this.cursor.track);
            return true;
        }

        if (!this.installation) {
            /*
            if (event.key === '/' && (event.ctrlKey || event.metaKey)) {
                this.focusSearch();
            } else if (event.key === '/' || event.key === ':' || event.key === '+') {
                this.cursor.show = false;
                if (this.state.commands.commandInput) {
                    this.state.commands.commandInput.focus();
                }
            }
            */

            if (event.key === 'x' && (event.metaKey || event.ctrlKey)) {
                if (this.state.commands.commandInput) {
                    this.state.commands.commandInput.focus();
                    this.dispatch(setCommandPrefix('M-x'));
                }
            }
        }

        if (event.key === 'm' && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            this.sequencerEngine.metronomeOn = !this.sequencerEngine.metronomeOn;
            return false;
        }

        if (event.key === '~') {
            this.halftime = this.sequencerEngine.subSequences.map(
                x => x.playhead.speedFactorParameter.get());
            this.sequencerEngine.subSequences.forEach(
                    (x, i) => x.playhead.speedFactorParameter.set(
                        this.halftime[i] / 2, false));
            
        }
        
        if (event.key === 'n' && (event.ctrlKey || event.ctrlKey)) {
            event.preventDefault();
            this.selectedTrack.auditionNext(true, true);
            return false;
        }

        if (event.key === 'R') {
            for (let sub of this.sequencerEngine.subSequences) {
                sub.tracks.forEach(
                    x => x.setIsEnabled(false));
            }
        }

        if (event.key === 'p' && (event.ctrlKey || event.ctrlKey)) {
            event.preventDefault();
            this.selectedTrack.auditionPrevious(true, true);
            return false;
        }

        if (event.key === 'i' && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            let track = this.selectedTrack;
            if (track && (!this.selectedEffect || !this.selectedEffect.name.includes('Effect Rack'))) {
                this.dispatch(
                    setTrackToConvert(track));
            }
        }

        if (event.key === 'Escape') {
            this.dispatch(setFullScreenZObject(undefined));
            //this.dispatch(setViMode(!this.viMode));
        }

        if (event.key === 'g' && event.metaKey) {
            // show groups
            event.preventDefault();
            if (!this.planarSelected) {
                this.groupSteps();
            }
            return true;
        }

        if (event.key === "\\" && event.metaKey) {
            this.dispatch(
                setSidebarsShowing(!this.state.spatial.sidebarsShowing));
        }

        if (event.key === 'z' && (event.metaKey || event.ctrlKey)) {
            event.preventDefault();
            if (event.shiftKey) {
                this.sequencerEngine.operationManager.redo();
            } else {
                this.sequencerEngine.operationManager.undo();
            }
            return true;
        } else if (event.key === 'k' && (event.metaKey || event.ctrlKey)) {
            if (this.midiMapMode === MAP) {
                this.dispatch(setMidiMapMode(OFF));
            }  else {
                this.dispatch(setMidiMapMode(MAP));
            }
            return true;
        } else if (event.key === 'y' && (event.metaKey || event.ctrlKey)) {
            event.preventDefault();
            segmentCables(this.sequencerEngine);
            return true;
        } else if (event.key === 'j' && (event.metaKey || event.ctrlKey)) {
            if (this.midiMapMode === DELETE) {
                this.dispatch(setMidiMapMode(OFF));
            }  else {
                this.dispatch(setMidiMapMode(DELETE));
            }
            return true;
        } else if (event.key === 'd' && (event.ctrlKey || event.metaKey)) {
            if (this.selectedEffect !== undefined &&
                (this.selectedEffect.name === 'Effect Rack' ||
                 this.selectedEffect.name === 'Midi Effect Rack')) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            if (this.selectedZObject && this.selectedZObject.getObjectType() === TRACK) {
                this.sequencerEngine.duplicateTrack(this.sequencerEngine.cursor.track);
            } else if (this.selectedZObject && this.selectedZObject.getObjectType() === ZOBJECT) {
                this.selectedZObject.duplicate();
            }
            return false;
        } else if (event.key === 'a' && (event.metaKey || event.ctrlKey)) {
            event.preventDefault();
            if (this.planarSelected) {
                return;
            }
            if (this.state.automation.show && this.state.sequencer.showPianoRoll &&
               this.state.arrangement.bottomMode === PIANO_ROLL) {
                this.selectAllTrackAutomationPoints();
            } else if (this.viewMode === ARRANGEMENT_VIEW) {
                if (this.state.arrangement.patternSelected)  {
                    this.selectAllTrackSteps();
                } else {
                    this.selectAllTrackAutomationPoints();
                }
            } else {
                this.selectAllTrackSteps();
            }
            this.dispatch(setSelectedFreeze(undefined));
            return false;
        } else if (event.key === 'E') {
	    event.preventDefault();
            this.dispatch(setUXLocked(!this.state.zobject.uxLocked));
	    return false;
        } else if (event.key === 'P') {
	    event.preventDefault();
            if (!this.state.spatial.showPadSequencer) {
                this.dispatch(setPresentationMode(!this.state.spatial.presentationMode));
            }
            return false;
        } else if (event.key === 'w' && (event.ctrlKey || event.ctrlKey)) {
	    event.preventDefault();
            if (this.viewMode === SEQUENCER_VIEW) {
                // show piano roll
                this.dispatch(setShowPianoRoll(!this.showPianoRoll));
                this.dispatch(setArrangementBottomMode(WAVEFORM));
            }
	    return false;
        } else if (event.key === 's' && (event.ctrlKey || event.metaKey)) {
            // auto-slice
            let track = this.selectedTrack;
            let sampler = track.getSamplers()[0];
            if (sampler) {
                sampler.autoSlice(4);
            }
        } else if (event.key === 'p' && (event.metaKey || event.ctrlKey)) {

	    event.preventDefault();
            // show piano roll
            this.dispatch(setSelectedZObject(undefined));
            this.dispatch(setShowPianoRoll(!this.showPianoRoll));
            this.dispatch(setArrangementBottomMode(PIANO_ROLL));
	    return false;
        } else if (event.key === 's' && (event.metaKey || event.ctrlKey)) {
            event.preventDefault();
            if (this.viewMode === SEQUENCER_VIEW) {
                let t = this.selectedTrack;
                let mode = this.state.cirklon.cirklonMode[t.id];
                this.dispatch(setCirklonMode(t.id, mode === "SLOPE" ? undefined : "SLOPE"));
            }
	    return false;
        } else if (event.key === 'g' && (event.metaKey || event.ctrlKey)) {
            event.preventDefault();
            if (this.viewMode === SEQUENCER_VIEW) {
                let t = this.selectedTrack;
                let mode = this.state.cirklon.cirklonMode[t.id];
                this.dispatch(setCirklonMode(t.id, mode === "GANG" ? undefined : "GANG"));
            }
	    return false;
        }

        if (isNumber(event.key) && (this.viewMode !== SEQUENCER_VIEW || !this.selectedEffect || this.selectedEffect.name !== "Plane Parameters")) {
            if (isClickOnBody) {
                this.onNumberKeyDown(event);
                return;
            }
        } else if (event.key === '=') {
            this.sequencerEngine.switchToNextPattern();
        } else if (event.key === '+') {
        } else if (event.key === '-') {
            this.sequencerEngine.switchToPreviousPattern();
        } else if (event.key === ']') {
            this.dispatch(setShowSequenceModal(true));
        } else if (event.key === 'c' && (event.metaKey || event.ctrlKey)) {
            this.copy();
        } else if (event.key === 'v' && (event.metaKey || event.ctrlKey)) {
            this.paste();
        } else if (event.key === 'b' && (event.metaKey || event.ctrlKey)) {
            this.duplicateSteps();
        } else if (event.key === 'l' && (event.metaKey || event.ctrlKey)) {
            event.preventDefault();
            this.legato();
            return false;
        } else if (event.key === 'r' && (event.ctrlKey)) {
            event.preventDefault();
            this.rollSteps();
            return false;
        } else if (event.key === 't' && (event.ctrlKey)) {
            event.preventDefault();
            this.tripletSteps();
            return false;
        } else if (event.key == 'Backspace' && !this.hasHigherOrderSteps()) {
            if (this.selectedFreeze !== undefined) {
                this.deleteSelectedFreeze();
                return;
            }
            if (this.pointsSelected.length > 0 &&
                ((this.showPianoRoll &&
                  this.state.automation.show) ||
                 this.viewMode === ARRANGEMENT_VIEW)
               ) {
                this.deleteSelectedPoints();
            } else if (this.viewMode === ARRANGEMENT_VIEW) {
                let steps = this.getSelectedSteps();
                if (steps && steps.length > 0) {
                    this.deleteSelectedSteps();
                } else {
                    arrangementBackspace(this.sequencerEngine);
                }
            } else {
                this.deleteSelectedSteps();
            }
        } else if (event.key == '`') {
            if (!this.sequencerEngine.isSequenceRolling) {
                this.sequencerEngine.sequenceRolling = true;
            }
        }
        else if (event.key == '\\' || (event.key == 'h' && event.ctrlKey)) {
            //event.preventDefault();
           // this.hide();
           return false;
        } else if (event.key == '.') {
            this.record();
        } else if (event.key === 'Meta' || event.key === 'Control') {
            this.onMetaKeyDown();
        } else if (event.key === 'Tab' && !this.disableTab) {
            event.preventDefault();

            if (this.isShowingSoundsPane()) {
                this.hideSidebar();
                return;
            }
            if (this.state.instruments.showingFormants) {
                return;
            }

            if (this.waveformShowing) {
                return;
            }
       } else if (event.key === '\'') {
            this.onClickRollingMode();
        } else if (event.key === 'Shift' && isClickOnBody) {
            this.onShiftKeyDown();
        } else if (event.key == 'ArrowRight' && isClickOnBody && !this.hasHigherOrderSteps()) {
            if (this.planarSelected) {
                return;
            }
            if (this.keyboardContext && this.keyboardContext.name === 'ztracker') {
                this.onArrowDown(event, true);
            } else {
                this.onArrowRight(event, true);
            }
        } else if (event.key == 'ArrowLeft' && isClickOnBody &&  !this.hasHigherOrderSteps()) {
            if (this.planarSelected) {
                return;
            }
            if (this.keyboardContext && this.keyboardContext.name === 'ztracker') {
                this.onArrowUp(event, true);
            } else {
                this.onArrowLeft(event, true);
            }
        } else if (event.key == 'ArrowUp' && isClickOnBody && !this.hasHigherOrderSteps()) {
            if (this.planarSelected) {
                return;
            }
            if (this.keyboardContext && this.keyboardContext.name === 'ztracker') {
                return this.onArrowLeft(event, true);
            } else {
                return this.onArrowUp(event);
            }
        } else if (event.key == 'ArrowDown' && isClickOnBody && !this.hasHigherOrderSteps()) {
            if (this.planarSelected) {
                return;
            }
            if (this.keyboardContext && this.keyboardContext.name === 'ztracker') {
                this.onArrowRight(event, true);
            } else {
                this.onArrowDown(event);
            }
        } else if (event.key == 'Enter' && isClickOnBody && !this.hasHigherOrderSteps()) {
            if (this.planarSelected) {
                return;
            }
            this.onEnterKeyDown();
        }
    }

    get waveformShowing() {
        return this.state.sequencer.waveformShowing;
    }

    onNumberKeyDown(event) {
        var number = parseInt(event.key);
        if (this.viewMode === ARRANGEMENT_VIEW && !this.isPlayingMix) {
            return;
        }
        if (this.sequencerEngine.rolling && !event.metaKey) {
            // if we are "rolling" then numbers changes the Resolution
            if (number >= 2 && number <= 9) {
                let resolution = NUMBER_TO_RESOLUTION[number];
                if (resolution !== null) {
                    this.sequencerEngine.resolution = resolution;
                }
            }
        } else {
            if (event.ctrlKey) {
                event.preventDefault();
                let trackNumber = number - 1;
                if (this.sequencerEngine.tracks[trackNumber]) {
                    this.sequencerEngine.selectTrack(trackNumber);
                    this.sequencerEngine.tracks[trackNumber].toggleEnabled();
                }
            } else {
                // simply hitting a number key switches to that pattern
                let pattern = number;
                this.sequencerEngine.switchToPattern(pattern - 1);
            }
        }
    }

    onMetaKeyDown() {
        this.dispatch(setCommandDown(true));
        this.lastMetaPressedTime = new Date().getTime();
    }

    hide() {
        let tracksToHide = this.state.tracks.tracksToHide;
        if (tracksToHide.length > 0) {
            // unhide
            this.dispatch(setTracksToHide([]));
            return;
        } else if (!this.sequencerEngine.tracks.some(
            t => t.isEffectsShowing())) {
            // if no effects are showing then we should
            // hide every track except the current one

            let tracks = this.sequencerEngine.tracks.filter(
                t => t !== this.selectedTrack);
            let tracksToHide = [
                ... this.state.tracks.tracksToHide.filter(
                    t => t !== this.selectedTrack),
                ...tracks
            ];
            this.dispatch(setTracksToHide(Array.from(new Set(tracksToHide))));
        }
        this.hideSidebar();
        this.dispatch(hideAllEffects(false));
        this.dispatch(setShowPianoRoll(false));
    }

    hideSidebar() {
        this.dispatch(setSelectorMode(false));
        this.dispatch(setShowInstruments(false));
        this.dispatch(setShowPresets(false));
        this.dispatch(setShowSequences(false));
        this.dispatch(setSidebarViewMode(SOUNDS));
    }

    selectAllTrackAutomationPoints() {
        let selectedTrack = this.sequencerEngine.tracks[this.cursor.track];
        if (selectedTrack === undefined) {
            return;
        }

        let parameter = this.state.automation.trackParameter[selectedTrack.id];
        if (parameter === undefined) {
            return;
        }
        let selectedPoints = this.state.automation.pointsSelected[selectedTrack.id] || [];
        if (selectedPoints.length > 0) {
            for (let track of this.sequencerEngine.tracks) {
                this.dispatch(setAutomationPointsSelected(track.id, []));
            }
        } else {
            if (this.viewMode === ARRANGEMENT_VIEW) {
                this.dispatch(setAutomationPointsSelected(
                    selectedTrack.id, [... parameter.mixAutomation.automations]));
            } else { 
                this.dispatch(setAutomationPointsSelected(
                    selectedTrack.id, [... parameter.automations]));
            }
        }
    }

    selectAllTrackSteps() {
        let selectedTrack = this.sequencerEngine.tracks[this.cursor.track];
        if (selectedTrack === undefined ||
            (this.viewMode === SEQUENCER_VIEW && selectedTrack.isEffectsShowing())) {
            if (this.state.sequencer.showPianoRoll &&
                this.state.arrangement.bottomMode === PIANO_ROLL) {
            } else {
                return;
            }
        }

        this.dispatch(setSampleExplorerSelected(false));
       

        let currentPattern = selectedTrack.currentPattern;
        let selectedSteps = this.getSelectedSteps();
        if (selectedSteps !== undefined) {
            this.dispatch(setSelectedPianoRollSteps(undefined));
            return;
        }

        let allSteps = selectedTrack.getEasyPattern().getAllSteps();
        this.dispatch(setSelectedPianoRollSteps(
            allSteps));
    }
    
    copy() {
        if (this.copiedNodesForRack.length > 0) {
            return;
        }
        if (this.selectedEffect) {
            this.effectToCopy = this.selectedEffect;
            this.dispatch(setStepsToCopy(undefined));
        } else {
            this.copySteps();
        }
    }

    paste() {
        if (this.copiedNodesForRack.length > 0) {
            return;
        }
        if (
            this.state.keyboard.stepsToCopy === undefined &&
            this.effectToCopy !== undefined &&
            this.selectedTrack !== undefined &&
            this.selectedTrack.isEffectsShowing()) {
            let copiedEffect = this.effectToCopy.isMidiEffect() ?
                this.effectToCopy.getCopy(this.selectedTrack) : 
                this.effectToCopy.getEffectCopy(this.sequencerEngine);

            if (!this.effectToCopy.isMidiEffect()) {
                this.selectedTrack.effectsChain.addEffect(copiedEffect);
            } else {
                this.selectedTrack.midiEffects.addEffect(copiedEffect);
            }
            this.sequencerEngine.update();
        } else {
            this.pasteSteps();
        }
    }

    copySteps() {
        let selectedSteps = this.getSelectedSteps();
        if (selectedSteps === undefined) {
            return;
        }
        this.dispatch(setStepsToCopy(selectedSteps));
        let track = this.selectedTrack;
        this.dispatch(setEasyPatternToCopy(track.getEasyPattern()));
    }
    
    pasteSteps() {

        if (this.state.keyboard.stepsToCopy === undefined) {
            return;
        }
        let stepNumber = this.cursor.getStep(this.resolution);
        let track = this.sequencerEngine.tracks[this.cursor.track];
        if (!track) {
            return;
        }
        let pastedSteps = track.getEasyPattern().pasteSteps(
            this.state.keyboard.stepsToCopy,
            {stepNumber: stepNumber},
            this.state.keyboard.easyPatternToCopy,
            this.state.sequencer.displayResolution
        );
        track.updateSteps()

        this.dispatch(
            setSelectedPianoRollSteps(
                pastedSteps));

        this.dispatch(
            setStepNumberDraggedTo(stepNumber));
    }

    record() {
        let isRecording = !this.isRecording;
        this.dispatch(setIsRecording(isRecording));
        this.sequencerEngine.recording(isRecording);
    }

    getSelectedSteps() {
        let state = this.sequencerEngine.store.getState();
        let steps = state.keyboard.selectedPianoRollSteps;
        if (steps && steps.length === 0) {
            return undefined;
        }
        return steps;
    }

    deleteSelectedPoints() {
        let parameter = this.state.automation.trackParameter[this.selectedTrack.id];
        if (parameter === undefined || !this.selectedTrack) {
            return;
        }
        this.sequencerEngine.operationManager.dispatch(removeAutomationBreakPoints(
            this.viewMode === ARRANGEMENT_VIEW ? parameter.mixAutomation : parameter.automation,
            this.pointsSelected));

        this.dispatch(setAutomationPointsSelected(this.selectedTrack.id, []));
    }
    
    deleteSelectedSteps() {
        let state = this.sequencerEngine.store.getState();
        let selectedSteps = this.getSelectedSteps();
        if (selectedSteps === undefined) {
            return;
        }

        this.sequencerEngine.operationManager.dispatch(deleteSteps(
            this.selectedTrack,
            selectedSteps));

        this.store.dispatch(setSelectedPianoRollSteps(undefined));
    }


    onShiftKeyDown() {
        // this.cursor.show = !this.cursor.show;
    }

    get currentScene() {
        return this.state.sequencer.currentScene;
    }

    get scenes() {
        return this.state.sequencer.scenes;
    }

    get showingSoundList() {
        return this.state.selector.showingSoundList ||
            this.state.packs.packSelected;
    }

    get currentSoundInList() {
        return this.state.selector.currentSoundInList;
    }

    set currentSoundInList(x) {
        this.dispatch(setCurrentSoundInList(x));
    }

    get currentTagInList() {
        return this.state.selector.currentTagInList;
    }

    set currentTagInList(x) {
        this.dispatch(setCurrentTagInList(x));
    }

    onClickRollingMode() {
        this.sequencerEngine.resolution = this.state.sequencer.displayResolution;
        this.dispatch(setTrackRolling(!this.trackRolling));
        this.dispatch(setViMode(false));
        this.sequencerEngine.rollingManager.clear();
    }

    onEnterKeyDown() {
        if (this.showingSoundList && this.currentSoundInList !== undefined) {
            return;
        }
        /*
        if (this.viewMode === MIX_VIEW) {
            if (this.trackerParameterToEdit) {
                if (this.trackerParameterToEdit.name === "Transpose") {
                    //  we want to toggle that step
                } else {
                    this.dispatch(setTrackerParameterToEdit(undefined));
                    return;
                }
            } else {
                let stepData = this.cursorStepData;
                if (stepData && stepData.on) {
                    let parameter = stepData.parameters.find(p => p.name === TRACKER_PARAMETERS[0]);
                    this.dispatch(setTrackerParameterToEdit(parameter));
                    return;
                } else {
                    // we want to toggle it
                }
            }
            this.dispatch(setTrackerParameterToEdit(undefined));
        }
        */
        if (this.cursor.track >= 0 &&
            this.cursor.track < this.sequencerEngine.tracks.length &&
            this.sequencerEngine.getSelectedStep() >= 0) {
            this.onClickStep(this.cursor.track, this.sequencerEngine.getSelectedStep());
        }
    }

    // toggles step on or off, and records in state, so we can sequence
    onClickStep(track,step) {
        if (this.getSelectedSteps() !== undefined) {
            return;
        }
        // on and off
        //this.sequencerEngine.tracks[track].toggleStep(step, this.resolution);
        this.sequencerEngine.tracks[track].pattern.clearCache();
        this.sequencerEngine.operationManager.dispatch(
            toggleStep(this.sequencerEngine.tracks[track], step, this.resolution));
        this.sequencerEngine.select(track, step);
        this.cursor.track = track;
    }

    dispatch(f) {
        this.store.dispatch(f);
    }

    get state() {
        return this.store.getState();
    }

    get selectedEffect() {
        if (!this.state.zobject.selectedZObject || this.state.zobject.selectedZObject.getObjectType() !== EFFECT) {
            return undefined;
        }
        if (this.state.effects.selectedEffect === undefined) {
            return undefined;
        }

        if (this.state.sequencer.showPianoRoll && this.state.arrangement.bottomMode === PIANO_ROLL) {
            return undefined;
        }

        return this.sequencerEngine.selectedEffect;
    }

    get planarSelected() {
        return this.state.zobject.selectedZObject && this.state.zobject.selectedZObject.name === "Plane Parameters";
    }

    get midiMapMode() {
        return this.state.midi.midiMapMode;
    }

    get viewMode() {
        return this.state.sequencer.viewMode;
    }

    get alternateViewMode() {
        return this.state.sequencer.alternateViewMode;
    }

    get showGroups() {
        return this.state.sequencer.showGroups;
    }

    get pointsSelected() {
        let selectedTrack = this.selectedTrack;
        if (!selectedTrack) {
            return [];
        }
        return this.state.automation.pointsSelected[selectedTrack.id] || [];
    }

    get isCompactMode() {
        return this.state.sequencer.isCompactMode;
    }

    get cursor() {
        return this.sequencerEngine.cursor;
    }

    get cursorStepData() {
        if (!this.selectedTrack) {
            return;
        }
        let stepBucket = this.selectedTrack.pattern.stepBuckets[this.cursor.step];
        return stepBucket.steps[0];
    }

    get resolution() {
        return this.state.sequencer.displayResolution;
    }

    get sampleAuditioning() {
        return this.state.audition.sampleAuditioning;
    }

    get trackRolling() {
        return this.state.sequencer.trackRolling;
    }

    get isRecording() {
        return this.state.sequencer.isRecording;
    }

    get selectedTrack() {
        return this.sequencerEngine.tracks[this.cursor.track];
    }

    get scripting() {
        return this.sequencerEngine.scripting;
    }

    get viMode() {
        return this.viewMode === SEQUENCER_VIEW && this.state.commands.viMode;
    }

    get trackFocused() {
        return this.state.sequencer.trackFocused;
    }

    get isPlayingMix() {
        return this.state.mix.isPlayingMix;
    }

    onSelectTrack(i) {
        this.sequencerEngine.cursor.track = i;
    }

    isShowingSoundsPane(checkSounds=true) {
        if (this.state.spatial.showSearchWindow) {
            return true;
        }
        if (this.state.selector.sidebarCollapsed) {
            return false;
        }
        return this.state.sequencer.showSelectorMode || 
            this.state.sequencer.sidebarViewMode !== SOUNDS;
    }

    get isShowingPianoRoll() {
        return this.showPianoRoll && this.state.arrangement.bottomMode === PIANO_ROLL;
    }

    get showPianoRoll() {
        return this.state.sequencer.showPianoRoll;
    }

    get showSamples2D() {
        return this.state.selector.showSamples2D;
    }

    get selectedFreeze() {
        return this.state.freeze.selectedFreeze;
    }

    deleteSelectedFreeze() {
        let track = this.selectedTrack;
        let frz = this.selectedFreeze;
        // delete the freeze
        for (let col of track.frozenColumns) {
            let index = -1;
            for (let i in col.frozenSamples) {
                if (col.frozenSamples[i].ipfsHash === frz) {
                    index = parseInt(i);
                }
            }
            
            if (index < 0) {
                continue;
            }
            
            col.frozenSettings.splice(index, 1);
            col.frozenSamples.splice(index, 1);
            col.frozenSamplers[index].gainNode.disconnect();
            col.frozenSamplers.splice(index, 1);
            col.updateRedux();
            break;
            // track.frozenSamplesToSave.splice(index, 1);
            
            /*
            for (let pattern of track.patterns) {
                if (pattern.frozenPatternPlaying !== undefined &&
                    pattern.frozenPatternPlaying >= index) {
                    pattern.frozenPatternPlaying--;
                }
            }
            */
        }
        
        if (track.frozenColumns.every(col => col.frozenSamplers.length === 0) &&
            track.isFrozen) {
            track.unfreeze();
        }

        this.dispatch(setSelectedFreeze(undefined));
    }

    get copiedNodesForRack() {
        return this.state.effects.copiedNodesForRack;
    }

    get trackerParameterToEdit() {
        return this.state.mix.trackerParameterToEdit;
    }

    newSlice() {
        let track = this.selectedTrack;
        if (track.getTrackType() === SAMPLER) {
            let sampler =  track.getSamplers()[0];
            sampler.newSlice();
            this.dispatch(setSelectedTrackSlice(
                track.id,
                sampler.slices.length - 1));
        }
    }

    moveSteps(steps, stepDifference, transposeDifference) {
        let transform = {
            stepDifference,
            transposeDifference
        };
        let track = steps[0].track;
        this.sequencerEngine.operationManager.dispatch(
            moveSteps(track, steps, transform, stepDifference === 0 ? undefined :  this.resolution, false, false));
    }

    duplicateSteps() {
        let track = this.selectedTrack;
        let selectedSteps = this.getSelectedSteps();
        let resolution = this.resolution;
        duplicateSteps(track, selectedSteps, resolution);
   }

    duplicateAllSteps() {
        this.sequencerEngine.tracks.forEach(
            track => {
                duplicateSteps(track, undefined, this.resolution);
            });
    }

    legato() {
        let track = this.selectedTrack;
        if (!track) {
            return;
        }
        let selectedSteps = this.getTrackSelectedSteps();
        if (!selectedSteps || selectedSteps.length === 0) {
            selectedSteps = track.getEasyPattern().getAllSteps();
        }
        legato(track, selectedSteps);
    }

    getTrackSelectedSteps() {
        let track = this.selectedTrack;
        if (!track) {
            return undefined;
        }
        let selectedSteps = this.getSelectedSteps();
        if (!selectedSteps || selectedSteps.length === 0) {
            selectedSteps = [this.cursorStepData];
        }
        return selectedSteps;
    }

    rollSteps() {
        let selectedSteps = this.getTrackSelectedSteps();
        if (!selectedSteps) {
            return;
        }
        let track = this.selectedTrack;
        rollSteps(track, selectedSteps);
    }

    tripletSteps() {
        let track = this.selectedTrack;
        let selectedSteps = this.getSelectedSteps();
        if (!track || !selectedSteps || selectedSteps.length === 0) {
            return;
        }
        tripletSteps(track, selectedSteps);
    }

    async focusSearch() {
        if (this.viewMode === ARRANGEMENT_VIEW ||
            this.viewMode === MIX_VIEW) {
            this.dispatch(setShowArrangementSearcher(true));
            await sleep(200);
        }

        let input = this.state.selector.searchInput;
        if (!input || !input.current || !input.current.focus) {
            return;
        }
        
        input.current.focus();
    }

    isEffectsShowing() {
        if (this.isShowingPianoRoll) { return false; }
        return this.selectedTrack &&
            this.selectedTrack.isEffectsShowing();
    }

    groupSteps() {
        let track = this.selectedTrack;
        if (!track) {
            return undefined;
        }
        let selectedSteps = this.getSelectedSteps();
        if (this.stepsGroupMode && selectedSteps && selectedSteps.every(
            g => !g.group)) {
            // if we're in steps group mode and selecting non-group step
            // then we simply group them
        } else if(this.stepsGroupMode || !selectedSteps || selectedSteps.length === 0 ||
                  selectedSteps.every(s => s.group)) {
            // if no steps are selected then toggle steps group mode
            this.toggleStepsGroupMode();
            this.dispatch(setSelectedPianoRollSteps(undefined));
            return;
        }

        groupSteps(selectedSteps, track);
    }

    get stepsGroupMode() {
        return this.state.groups.stepsGroupMode;
    }
    
    toggleStepsGroupMode() {
        this.dispatch(
            setStepsGroupMode(!this.stepsGroupMode));
        this.sequencerEngine.updateSteps();
    }

    get sampleExplorerSelected() {
        return this.state.selector.sampleExplorerSelected;
    }

    hasHigherOrderSteps() {
        let {selectedSteps} = this.state.higherOrder;
        return selectedSteps && selectedSteps.length > 0;
    }

    get selectedZObject() {
        return this.state.zobject.selectedZObject;
    }

    get keyboardContext() {
        return this.state.keyboard.keyboardContext
    }
}

export default KeyListener;
